document.addEventListener("DOMContentLoaded", function () {

    /* ---------------------------
       COUNTDOWN TIMER
    --------------------------- */
    function startCountdown(durationInSeconds) {
        let remainingTime = durationInSeconds;

        const hoursEl = document.getElementById('hours');
        const minutesEl = document.getElementById('minutes');
        const secondsEl = document.getElementById('seconds');

        if (!hoursEl || !minutesEl || !secondsEl) return;

        function updateDisplay() {
            const hours = Math.floor(remainingTime / 3600);
            const minutes = Math.floor((remainingTime % 3600) / 60);
            const seconds = remainingTime % 60;

            hoursEl.textContent = String(hours).padStart(2, '0');
            minutesEl.textContent = String(minutes).padStart(2, '0');
            secondsEl.textContent = String(seconds).padStart(2, '0');
        }

        updateDisplay();

        const countdownInterval = setInterval(() => {
            if (remainingTime <= 0) {
                clearInterval(countdownInterval);
            } else {
                remainingTime--;
                updateDisplay();
            }
        }, 1000);
    }

    // 4 hours 12 minutes 34 seconds = 15154 seconds
    startCountdown(15154);



    /* ---------------------------
       SWIPER BANNER
    --------------------------- */
    if (typeof Swiper !== "undefined") {
        var swiper = new Swiper('.swiper-container', {
            speed: 500,
            direction: 'vertical',
            mousewheel: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            watchOverflow: true,
            on: {
                slideChange: function () {
                    setTimeout(() => {
                        swiper.params.touchReleaseOnEdges = false;
                        swiper.params.mousewheel.releaseOnEdges = false;
                    });
                },
                reachEnd: function () {
                    setTimeout(() => {
                        swiper.params.touchReleaseOnEdges = true;
                        swiper.params.mousewheel.releaseOnEdges = true;
                    }, 500);
                },
                reachBeginning: function () {
                    setTimeout(() => {
                        swiper.params.touchReleaseOnEdges = true;
                        swiper.params.mousewheel.releaseOnEdges = true;
                    }, 500);
                }
            }
        });
    }



    /* ---------------------------
       ADD-TO-CART → DIRECT CHECKOUT
    --------------------------- */
    document.querySelectorAll('.add-to-cart-form').forEach(form => {
        form.addEventListener('submit', function (e) {
            e.preventDefault();

            fetch('/cart/add', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams(new FormData(this))
            })
                .then(response => {
                    if (response.ok) {
                        window.location.href = '/checkout';
                    } else {
                        console.error('Failed to add product to cart.');
                    }
                })
                .catch(error => console.error('Error:', error));
        });
    });



    /* ---------------------------
       ACCORDION
    --------------------------- */
    const accordionItems = document.querySelectorAll(".accordion-item");

    if (accordionItems.length > 0) {
        accordionItems[0].classList.add("active");

        accordionItems.forEach(item => {
            const header = item.querySelector(".accordion-header");

            header.addEventListener("click", function (e) {
                e.preventDefault();

                const isActive = item.classList.contains("active");

                accordionItems.forEach(i => i.classList.remove("active"));

                if (!isActive) {
                    item.classList.add("active");
                }
            });
        });
    }



    /* ---------------------------
       CUSTOM LOGIN PAGE CLASS
    --------------------------- */
    if (window.location.pathname.includes("/account/login")) {
        document.body.classList.add("custom-login-page");
    }



    /* ---------------------------
       SLICK SLIDERS
    --------------------------- */
    if (typeof $ !== "undefined" && typeof $.fn.slick !== "undefined") {

        $('.masanaryimagesslide').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '40px',
            adaptiveHeight: true,
            arrows: true,
            dots: false
        });

        $('#homereviewmobileshow').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            adaptiveHeight: true,
            arrows: true,
            dots: false
        });
    }

});

document.addEventListener("click", function (e) {
  const btn = e.target.closest(".product-form__submit");
  if (!btn) return;

  // Wait for Shopify's built-in add-to-cart to finish
  setTimeout(() => {
    fetch("/cart.js")
      .then(r => r.json())
      .then(cart => {
        const count = cart.item_count;

        // Update ANY cart bubble automatically
        const bubbles = document.querySelectorAll("[data-cart-count], .cart-count-bubble, .cart-count-bubble span, .count-bubble");

        bubbles.forEach(el => {
          el.textContent = count;
        });
      });
  }, 300);
});
